import axios from "axios";

export type OutboundRequest = {
  uuid: string;
  recipient: string;
  amount?: number;
  comment: string;
  longComment: string;
};

export function postOutbound(request: OutboundRequest) {
  return axios.post("/api/wh/outbound", request);
}

export type InventoryRequest = {
  uuid: string;
  isAvailable?: boolean;
  amount?: number;
  comment: string;
  longComment: string;
};

export function postInventory(request: InventoryRequest) {
  return axios.post("/api/wh/inventory", request);
}

export type WarehouseTransferRequest = {
  articleUuid: string;
  warehouse: string;
  comment: string;
  amount: number;
};

export function transferWarehouse(request: WarehouseTransferRequest) {
  return axios.post("/api/wh/transport", request);
}
